import React, { FC } from 'react';
import styled from 'styled-components';
import { SearchInput } from '../input/input';

const FiltersRowContainer = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
`;

const FiltersControls = styled.div`
    display: flex;
    align-items: end;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
`;

const SearchInputContainer = styled.div<{ $pushRight: boolean }>`
    min-width: 300px;
    margin-left: ${(props) => (props.$pushRight ? 'auto' : undefined)};

    & > * {
        width: 100%;
    }
`;

const RightControls = styled.div<{ $pushRight: boolean }>`
    display: flex;
    align-items: end;
    gap: 8px;
    flex-wrap: wrap;
    margin-left: ${(props) => (props.$pushRight ? 'auto' : undefined)};
`;

export interface FiltersRowProps extends React.HTMLAttributes<HTMLDivElement> {
    showSearch?: boolean;
    onSearchChange?: (filter: string) => void;
    placeholder?: string;
    value?: string;
    autoFocus?: boolean;
    children?: React.ReactNode;
    left?: React.ReactNode;
    right?: React.ReactNode;
}

export const FiltersRow: FC<FiltersRowProps> = ({ showSearch, onSearchChange, placeholder, value, autoFocus, children, left, right, className, ...rest }) => {
    const hasLeftControls = !!left || !!children;

    return (
        <FiltersRowContainer className={className} {...rest}>
            {hasLeftControls && (
                <FiltersControls>
                    {left}
                    {children}
                </FiltersControls>
            )}
            {showSearch && (
                <SearchInputContainer className='search-input-container' $pushRight>
                    <SearchInput autoFocus={autoFocus} placeholder={placeholder} value={value} onChange={(e) => onSearchChange?.(e.currentTarget.value)} />
                </SearchInputContainer>
            )}
            {right && <RightControls $pushRight={!showSearch}>{right}</RightControls>}
        </FiltersRowContainer>
    );
};
